import { NgModule } from '@angular/core';

import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

@NgModule({
  imports: [
    NzTableModule,
    NzToolTipModule,
    NzTagModule,
    NzPopconfirmModule,
    NzDrawerModule,
    NzFormModule,
    NzSelectModule,
    NzGridModule,
    NzRadioModule,
    NzInputModule,
    NzInputNumberModule,
    NzCardModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzUploadModule,
    NzButtonModule,
    NzModalModule,
    NzSpinModule,
    NzBadgeModule,
    NzTabsModule,
    NzAlertModule,
    NzPageHeaderModule,
    NzDividerModule,
    NzTreeModule,
    NzSwitchModule,
    NzLayoutModule,
    NzPopoverModule,
    NzAvatarModule,
    NzSkeletonModule,
    NzNotificationModule,
    NzMenuModule,
    NzCollapseModule,
    NzTreeSelectModule,
    NzIconModule,
    NzResizableModule,
    NzNoAnimationModule,
    NzEmptyModule,
    NzListModule,
    NzTimePickerModule,
    NzStatisticModule,
    NzPaginationModule,
    NzDropDownModule,
  ],
  exports: [
    NzTableModule,
    NzToolTipModule,
    NzTagModule,
    NzPopconfirmModule,
    NzDrawerModule,
    NzFormModule,
    NzSelectModule,
    NzGridModule,
    NzRadioModule,
    NzInputModule,
    NzInputNumberModule,
    NzCardModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzUploadModule,
    NzButtonModule,
    NzModalModule,
    NzSpinModule,
    NzBadgeModule,
    NzTabsModule,
    NzAlertModule,
    NzPageHeaderModule,
    NzDividerModule,
    NzTreeModule,
    NzSwitchModule,
    NzLayoutModule,
    NzPopoverModule,
    NzAvatarModule,
    NzSkeletonModule,
    NzNotificationModule,
    NzMenuModule,
    NzCollapseModule,
    NzTreeSelectModule,
    NzIconModule,
    NzResizableModule,
    NzNoAnimationModule,
    NzEmptyModule,
    NzListModule,
    NzTimePickerModule,
    NzStatisticModule,
    NzPaginationModule,
    NzDropDownModule,
  ]
})

export class AppZorroModule {
}
